import(/* webpackMode: "eager" */ "/home/rajesh/feed/feed_lms/src/app/forgot-password/page.tsx");
